export function setStatus(status){
  switch (status) {
    case 1:
      return "跟进中"
    case 5:
      return "已成交"
    case 7:
      return "订单分配失败"
    case 10:
      return "已支付/待发货"
    case 15:
      return "已发货"
    case 25:
      return "已收货"
    case 30:
      return "申请售后"
    case 35:
      return "申请换货"
    case 40:
      return "申请退款"
    case 45:
      return "已换货"
    case 50:
      return "已退款"
    case 51:
      return "退款失败"
    case 60:
      return "交易完成（已评价）"
    case 65:
      return "已终止"
    case 70:
      return "订单已关闭"
    case 75:
      return "已支付待审核"
    case 80:
      return "待提交支付材料"
    case 85:
      return "审核不通过"
      break;

    default:
      break;
  }
}



// WEBPACK FOOTER //
// ./src/utils/orderStatus.js